(() => {
  if (globalThis.GiestoColorGroups) return;

  const normalize = value => String(value || '').normalize('NFKD')
    .replace(/\p{M}/gu, '').toLowerCase().replace(/ı/g, 'i')
    .replace(/[^a-z0-9]+/g, ' ').trim();
  const identity = product => String(product.id || '').replace('gid://shopify/Product/', '');
  let seasonOrderPromise;
  let seasonCatalog = [];
  function seasonOrder() {
    if (!seasonOrderPromise) seasonOrderPromise = (async () => {
      try {
        const page = async number => {
          const url = new URL('/collections/tumunu-gor-f-w27', location.origin);
          url.searchParams.set('view', 'giesto-story-families');
          url.searchParams.set('sort_by', 'manual');
          url.searchParams.set('page', number);
          const theme = globalThis.Shopify?.theme;
          if (theme?.id && !['main', 'live'].includes(theme.role)) url.searchParams.set('preview_theme_id', theme.id);
          for (let attempt = 0; attempt < 2; attempt++) {
            try {
              const response = await fetch(url, { signal: AbortSignal.timeout(6000) });
              if (!response.ok) throw new Error('Season order unavailable');
              const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
              const data = JSON.parse(doc.querySelector('[data-story-families]').textContent);
              if (!Array.isArray(data.products)) throw new Error('Missing season products');
              return data;
            } catch (error) { if (attempt === 1) throw error; }
          }
        };
        const first = await page(1);
        const pages = [first];
        const count = Number(first.pages);
        if (!Number.isInteger(count) || count < 1 || count > 100) throw new Error('Invalid season pagination');
        for (let number = 2; number <= count; number += 4) {
          pages.push(...await Promise.all(Array.from({ length: Math.min(4, count - number + 1) }, (_, index) => page(number + index))));
        }
        seasonCatalog = pages.flatMap(data => data.products);
        return seasonCatalog.map(product => String(product[0]));
      } catch { seasonOrderPromise = null; return []; }
    })();
    return seasonOrderPromise;
  }
  function orderProducts(products, ids) {
    const ranks = new Map(ids.map((id, index) => [String(id), index]));
    return products.slice().sort((a, b) => (ranks.get(identity(a)) ?? ids.length) - (ranks.get(identity(b)) ?? ids.length));
  }
  const model = (title, color) => {
    const name = ` ${normalize(title)} `;
    const normalizedColor = normalize(color);
    const candidates = normalizedColor === 'kahve' ? ['kahverengi', 'kahve'] : [normalizedColor];
    const shade = candidates.filter(Boolean).map(value => ` ${value} `).find(value => name.includes(value));
    if (!shade) return null;
    return name.replace(shade, ' ').trim().replace(/ +/g, ' ');
  };

  function match(container, group) {
    const products = group?.products || [];
    const current = products.find(product => identity(product) === container.dataset.p);
    if (!current) return { ...group, products: [] };
    // Compare records from the same canonical catalog. Storefront titles and
    // option values are translated, while the app's group records may not be.
    const family = model(current.title, current.color);
    const matches = products.filter(product => identity(product) === container.dataset.p ||
      (family && model(product.title, product.color) === family));
    return {
      ...group,
      products: matches.map(product => ({
        ...product,
        // Keep Turkish combining characters intact, encoded once in the path.
        handle: encodeURIComponent(decodeURIComponent(product.handle || '')),
        color: container.dataset.locale === 'en' ? englishColors[normalize(product.color)] || product.color : product.color,
      })),
    };
  }

  const englishColors = {
    beyaz: 'White', siyah: 'Black', lacivert: 'Navy', mavi: 'Blue', 'acik mavi': 'Light blue',
    kahve: 'Brown', bej: 'Beige', haki: 'Khaki', sari: 'Yellow', kahverengi: 'Brown', yesil: 'Green',
    'petrol yesil': 'Petrol green', turuncu: 'Orange', bordo: 'Burgundy', kirmizi: 'Red',
    mint: 'Mint', pembe: 'Pink', ekru: 'Ecru', gri: 'Grey', antrasit: 'Anthracite',
    taba: 'Tan', indigo: 'Indigo', mor: 'Purple', krem: 'Cream', tas: 'Stone',
    gumus: 'Silver', altin: 'Gold', 'acik gri': 'Light grey', 'koyu gri': 'Dark grey',
    'koyu mavi': 'Dark blue', 'acik yesil': 'Light green', 'koyu yesil': 'Dark green',
  };
  function localizeLinks(container) {
    const root = (container.dataset.root || '/').replace(/\/$/, '');
    for (const anchor of container.querySelectorAll('a[href^="/products/"]')) {
      anchor.setAttribute('href', root + anchor.getAttribute('href'));
    }
  }
  globalThis.GiestoColorGroups = { match, model, localizeLinks, seasonOrder, orderProducts, seasonCatalog: async () => { await seasonOrder(); return seasonCatalog; } };
  globalThis.document?.dispatchEvent(new Event('giesto:color-groups-ready'));
})();
